module.exports = __webpack_public_path__ + "img/aponix.135ed765.jpg";